import { Box, Tooltip, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import Iconify from '../../../../../reusable-components/iconify';

IconBadge.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  icon: PropTypes.string,
  color: PropTypes.string,
  text: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md']),
};

export default function IconBadge({ title, icon = "", color = "info", size = "md", text = "" }) {

  const sizing = {
    width: size === "md" ? 30 : 16,
    height: size === "md" ? 20 : 16,
    borderRadius: size === "md" ? "12px" : "4px",
    iconifySize: size === "md" ? "12px" : "4px"
  }

  return (
    <Tooltip title={title}>
      <Box sx={{
        color: "#fff", width: sizing.width, height: sizing.height,
        bgcolor: `${color}.main`, borderRadius: sizing.borderRadius,
        display: "flex", justifyContent: "center", alignItems: "center", zIndex: 3
      }} >
        {text ?
          <Typography variant="caption">{text}</Typography>
          :
          <Iconify icon={icon} color="white" fontSize={sizing.iconifySize} />}
      </Box>
    </Tooltip>
  )

}